/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ArjDependencySettingsType from '@jira/spa-apps__advanced-roadmaps-dependencies-settings/src/ArjSettingsDependencies.tsx';
import type ArjLoadingLimitsSettingsType from '@jira/spa-apps__advanced-roadmaps-loading-limits-settings/src/LoadingLimits.tsx';
import type ArjPermissionsSettingsType from '@jira/spa-apps__advanced-roadmaps-permissions-settings/src/ArjSettingsPermissions.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plans Settings - Dependencies
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyArjSettingsDependencies: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ArjDependencySettingsType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-arj-settings-dependencies", jiraSpaEntry: "async-arj-settings-dependencies" */ '@jira/spa-apps__advanced-roadmaps-dependencies-settings/src/ArjSettingsDependencies.tsx'
			),
		),
	{ ssr: false },
);

export const ArjSettingsDependencies = (): React.JSX.Element => (
	<LazyPage
		Page={LazyArjSettingsDependencies}
		pageId="arj-settings-dependencies"
		shouldShowSpinner
	/>
);

/**
 * Plans Settings - Loading Limits
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyArjSettingsLoadingLimits: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ArjLoadingLimitsSettingsType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-arj-settings-loading-limits", jiraSpaEntry: "async-arj-settings-loading-limits" */ '@jira/spa-apps__advanced-roadmaps-loading-limits-settings/src/LoadingLimits.tsx'
			),
		),
	{ ssr: false },
);

export const ArjSettingsLoadingLimits = (): React.JSX.Element => (
	<LazyPage
		Page={LazyArjSettingsLoadingLimits}
		pageId="arj-settings-loading-limits"
		shouldShowSpinner
	/>
);

/**
 * Plans Settings - Permissions
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyArjSettingsPermissions: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ArjPermissionsSettingsType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-arj-settings-permissions", jiraSpaEntry: "async-arj-settings-permissions" */ '@jira/spa-apps__advanced-roadmaps-permissions-settings/src/ArjSettingsPermissions.tsx'
			),
		),
	{ ssr: false },
);

export const ArjSettingsPermissions = (): React.JSX.Element => (
	<LazyPage Page={LazyArjSettingsPermissions} pageId="arj-settings-permissions" shouldShowSpinner />
);
